import Icon, { BaseIconProps } from './react-components/Icon'

/**
 * Renders the generated SVG icon PayInvoicesIcon as a React component.
 * These icons are rendered with special wrapper helpers via our internal <Icon> component,
 * which is built on top of MUI's <SvgIcon> component.
 * If you're experiencing rendering issues, contact the UIPT team or consult the docs
 * for the underlying components. Do not modify this icon directly. It is a generated file.
 */ const PayInvoicesIcon = (props: BaseIconProps) => {
  return (
    <Icon {...props} nativeViewbox="0 0 24 24">
      <path
        d="M9.79687 21H6.625H3.5C3.22386 21 3 20.7761 3 20.5V3.5C3 3.22386 3.22386 3 3.5 3H6.625H10.25H13.875H17C17.2761 3 17.5 3.22386 17.5 3.5V10.65"
        stroke="#503291"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.5 22C18.9853 22 21 19.9853 21 17.5C21 15.0147 18.9853 13 16.5 13C14.0147 13 12 15.0147 12 17.5C12 19.9853 14.0147 22 16.5 22Z"
        stroke="#503291"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.5 18L16 19.5L19 16"
        stroke="#503291"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.3227 8.55868C10.0482 8.1946 9.6684 7.92368 9.23481 7.78246C8.80122 7.64124 8.33472 7.63649 7.89841 7.76904C6.21337 8.14687 6.1169 10.4304 8.36284 10.3562C10.6088 10.2819 10.9685 12.0904 9.86131 12.9139C9.59973 13.0971 9.30393 13.2259 8.99156 13.2926C8.67919 13.3592 8.35658 13.3623 8.04298 13.3017C7.72938 13.2411 7.43118 13.118 7.16609 12.9399C6.90101 12.7617 6.67448 12.532 6.49996 12.2644"
        stroke="#503291"
        strokeLinecap="round"
      />
      <path
        d="M8.48376 5.87518V7.35615"
        stroke="#503291"
        strokeLinecap="round"
      />
      <path
        d="M8.48376 13.7054V14.8751"
        stroke="#503291"
        strokeLinecap="round"
      />
    </Icon>
  )
}
export default PayInvoicesIcon
